/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { XSquareIcon16Light } from './XSquareIcon16Light';
import { XSquareIcon16Regular } from './XSquareIcon16Regular';
import { XSquareIcon16Solid } from './XSquareIcon16Solid';
import { XSquareIcon20Light } from './XSquareIcon20Light';
import { XSquareIcon20Regular } from './XSquareIcon20Regular';
import { XSquareIcon20Solid } from './XSquareIcon20Solid';
import { XSquareIcon24Regular } from './XSquareIcon24Regular';
import { XSquareIcon24Solid } from './XSquareIcon24Solid';
import { XSquareIcon32Regular } from './XSquareIcon32Regular';
import { XSquareIcon64Regular } from './XSquareIcon64Regular';
var sizes = {
    16: {
        light: XSquareIcon16Light,
        regular: XSquareIcon16Regular,
        solid: XSquareIcon16Solid,
    },
    20: {
        light: XSquareIcon20Light,
        regular: XSquareIcon20Regular,
        solid: XSquareIcon20Solid,
    },
    24: {
        regular: XSquareIcon24Regular,
        solid: XSquareIcon24Solid,
    },
    32: {
        regular: XSquareIcon32Regular,
    },
    64: {
        regular: XSquareIcon64Regular,
    },
};
export var XSquareIcon = forwardRef('XSquareIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
